import React from 'react';

export const ToggleSwitch = ({ checked, onChange, isRTL, disabled, testId, label }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={label}
    onClick={onChange}
    disabled={disabled}
    className="relative shrink-0 rounded-full"
    style={{
      width: 40, height: 22, border: 'none',
      background: checked ? '#10B981' : 'rgba(148,163,184,0.45)',
      opacity: disabled ? 0.6 : 1,
      transition: 'background-color 150ms, opacity 150ms',
    }}
    data-testid={testId}
  >
    <span
      className="absolute top-[3px] rounded-full bg-white shadow"
      style={{
        width: 16, height: 16,
        [isRTL ? 'right' : 'left']: checked ? 21 : 3,
        transition: 'left 150ms, right 150ms',
      }}
    />
  </button>
);
